export const RESEND_FORWARD_CONSENT_FORM = "RESEND_FORWARD_CONSENT_FORM"
export const RESEND_FORWARD_CONSENT_FORM_SUCCESS = "RESEND_FORWARD_CONSENT_FORM_SUCCESS"
export const RESEND_FORWARD_CONSENT_FORM_ERROR = "RESEND_FORWARD_CONSENT_FORM_ERROR"
export const CLEAR_FORM_API_CALLED = "CLEAR_FORM_API_CALLED"